{{#each this}}
<p>
  {{sentence}}
</p>
{{/each}}